import { Cell, CellImage, Pagination, Table, TableHeader, TableRow, Text } from '@recargas-dominicanas/core/components';
import { style } from './transactions.module.css';
import { useBusinessStore } from '../../../stores/businessStore';
import { useEffect, useRef } from 'react';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';

export function Transactions() {;

  const { business, transactions, fetchTransactions } = useBusinessStore();

  const tableRef = useRef<HTMLTableElement>(null);
  
  useEffect(() => {
    if (tableRef.current) tableRef.current.scrollTop = 0;
  }, [transactions]);

  async function handleFetchTransactions(page: number, size: number) {
    await fetchTransactions(business!.id, page, size);
  }

  if (!transactions) return null;

  return (
    <div className={style.container}>
      <div className={style.content}>
        <Table 
          style={style.table}
          refElement={tableRef}>
          <TableHeader style={style.tableHeader}>
            <Text text='Comp.'/>
            <Text text='Teléfono'/>
            <Text text='Monto'/>
            <Text text='Tipo'/>
            <Text text='Fecha'/>
            {transactions.data[0]?.business && <Text text='Negocio'/>}
            <Text text='Estado'/>
          </TableHeader>
          <tbody>
            {
              transactions.data.map(transaction => (
                <TableRow key={transaction.id} style={style.tableRow}>
                  <CellImage src={transaction.product.image}/>
                  {(transaction.product.type === 'Recarga' || transaction.product.type === 'Paquetico') &&
                    <Cell className={style.phone} text={transaction.phone}/>
                  }
                  {transaction.product.type === 'Pin' &&
                    <Cell className={style.phone} text='* * * * * * * *'/>
                  }
                  {transaction.product.type === 'Factura' &&
                    <Cell className={style.phone} text={transaction.contract?.nic}/>
                  }
                  <Cell weight='medium' color='green' text={formatCurrency(transaction.amount)}/>
                  <Cell text={transaction.product.type}/>
                  <Cell text={formatDate(transaction.date)}/>
                  {transaction.business && <Cell text={transaction.business.name}/>}
                  {transaction.cancelled
                    ? <Cell color='red' weight='medium' text='Cancelada'/>
                    : <Cell color='darkgray' text='Realizada'/>
                  }
                </TableRow>
              ))
            }
          </tbody>
        </Table>
      </div>
      <Pagination
        title='Transacciones'
        index={transactions.index}
        pages={transactions.pages}
        count={transactions.count}
        size={transactions.size}
        onChange={handleFetchTransactions}/>
    </div>
  );
}
